import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomePage from '../views/home-page.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)



const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        redirect: '/homepage',
        children: [{
                name: 'homepage',
                path: '/homepage',
                component: HomePage
            },
            {
                name: 'assitant',
                path: '/assitant',
                component: () =>
                    import ('../views/product/huisheng-assist.vue')
            },
            {
                name: 'call',
                path: '/call',
                component: () =>
                    import ('../views/product/huisheng-call.vue')
            },
            {
                name: 'quality',
                path: '/quality',
                component: () =>
                    import ('../views/product/huisheng-quality.vue')
            },
            {
                name: 'service',
                path: '/service',
                component: () =>
                    import ('../views/product/huisheng-service.vue')
            },
            {
                name: 'homepage',
                path: '/homepage',
                component: () =>
                    import ('../views/home-page.vue')
            },
            {
                name: 'solution',
                path: '/solution',
                component: () =>
                    import ('../views/my-solution.vue')
            },
            {
                name: 'introduce',
                path: '/introduce',
                component: () =>
                    import ('../views/my-introduce.vue')
            }

        ]
    },
    // {
    //     name: 'register',
    //     path: '/register',
    //     component: () =>
    //         import ('../views/my-register.vue')
    // }

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router